import React from "react";

const FormRow = ({ children }: React.PropsWithChildren) => (
  <div className="flex flex-column md:flex-row md:gap-3 px-1">{children}</div>
);

export default FormRow;
